/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FAQCategories } from '../models/FAQCategories';
import type { FrequentlyAskingQuestionDTO } from '../models/FrequentlyAskingQuestionDTO';
import type { FrequentlyAskingQuestionDTOPagedListData } from '../models/FrequentlyAskingQuestionDTOPagedListData';
import type { FrequentlyAskingQuestionInput } from '../models/FrequentlyAskingQuestionInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FrequentlyAskingQuestionService {

  /**
   * @param category
 *
 * 0 = Sales
 *
 * 1 = Service
 *
 * 2 = Parts
 *
 * 3 = Other
   * @param searchText 
   * @param isSiteVisible 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns FrequentlyAskingQuestionDTOPagedListData Success
   * @throws ApiError
   */
  public static getFrequentlyAskingQuestions(
category?: FAQCategories,
searchText?: string,
isSiteVisible?: boolean,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<FrequentlyAskingQuestionDTOPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/frequently-asking-questions',
      query: {
        'Category': category,
        'SearchText': searchText,
        'IsSiteVisible': isSiteVisible,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postFrequentlyAskingQuestions(
requestBody?: FrequentlyAskingQuestionInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/frequently-asking-questions',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns FrequentlyAskingQuestionDTO Success
   * @throws ApiError
   */
  public static getFrequentlyAskingQuestions1(
id: number,
): CancelablePromise<FrequentlyAskingQuestionDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/frequently-asking-questions/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putFrequentlyAskingQuestions(
id: number,
requestBody?: FrequentlyAskingQuestionInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/frequently-asking-questions/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteFrequentlyAskingQuestions(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/frequently-asking-questions/{id}',
      path: {
        'id': id,
      },
    });
  }

}
